<template>
  <RouterView />
  <LoginDialog />
</template>

<script setup>
import { RouterView } from "vue-router";
import LoginDialog from "@/views/home/components/LoginDialog.vue";
import { onMounted, onUnmounted, watch } from "vue";
import { useFilesSelection } from "@/composables/dashboard/cloudspace/useFilesSelection";
import { useLogin } from "@/composables/login/useLogin";
import { useUploadDialog } from "@/composables/upload/useUploadDialog";

const {
  action: { setupKeyboardEvents, cleanupKeyboardEvents },
} = useFilesSelection();

const {
  state: { isShowLoginDialog },
} = useLogin();

const {
  action: { handleLoginDialogChange },
} = useUploadDialog();

// 监听登录弹窗状态变化
watch(isShowLoginDialog, handleLoginDialogChange);

onMounted(() => {
  setupKeyboardEvents();
});

onUnmounted(() => {
  cleanupKeyboardEvents();
});
</script>

<style lang="scss">
html,
body {
  margin: 0;
  height: 100%;
  width: 100%;
  background: black;
  font-size: 16px;
  transition: font-size 0.3s ease;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

@media (width >= 1920px) {
  html,
  body {
    font-size: 18px;
  }
}

#app {
  height: 100%;
  width: 100%;
  position: relative;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
  margin: 0;
  padding: 0;
  border: 0;
}

@import "@/font/cn_font.css";
</style>
